import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { Separator } from '@synoptic/ui-kit/separator/separator.js';
import { ErrorPage } from '@/components/error-page/error-page.tsx';
import { HomeAuthorsSection } from './sections/authors-section/home-authors-section';
import { HomeStreamPackagesBanner } from './sections/stream-packages-banner/home-stream-packages-banner';
import { HomeStreamsSection } from './sections/streams-section/home-streams-section';
import { homeExplorePage } from './home.css';

export const ErrorBoundary = ErrorPage;

export default function HomeExplorePage() {
  const isMobile = !useIsTablet();
  return (
    <div className={homeExplorePage}>
      <HomeStreamsSection />
      {isMobile && <Separator />}
      <HomeStreamPackagesBanner />
      {isMobile && <Separator />}
      <HomeAuthorsSection />
    </div>
  );
}
